<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <div class="panel margin--bottom">
          <bar-card :bg="'border10'">
            <v-title>
              大事记
            </v-title>
            <div class="content">
              <div class="closeDraw">
                <el-button icon="el-icon-close" @click="closeClick"></el-button>
              </div>
              <div class="tabPanel">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="全部" name=" ">
                    <ul class="el-timeline">
                      <li
                        v-for="(item, index) in allList"
                        :key="index"
                        class="el-timeline-item"
                      >
                        <div class="el-timeline-item__tail"></div>
                        <img
                          src="~images/index/btnGroup/node.png"
                          class="node__img"
                        />
                        <div class="el-timeline-item__wrapper">
                          <div class="el-timeline-item__timestamp is-top">
                            {{
                              $formatDate(
                                new Date(item.systemusertime),
                                "yyyy-MM-dd"
                              )
                            }}
                          </div>
                          <div class="el-timeline-item__content">
                            <div
                              class="flex"
                              style="padding:0px 10px 0 5px;align-items: flex-start;"
                            >
                              <border-box>
                                <img class="infoImg" v-lazy="item.img" />
                              </border-box>
                              <div class="msg">{{ item.info }}</div>
                            </div>
                          </div>
                          <div
                            class="el-timeline-item__timestamp is-bottom"
                          ></div>
                        </div>
                      </li>
                    </ul>
                  </el-tab-pane>
                  <el-tab-pane
                    :label="item + '年'"
                    :name="item"
                    v-for="(item, index) in years"
                    :key="index"
                  >
                    <ul class="el-timeline">
                      <li
                        v-for="(item1, index) in list"
                        :key="index"
                        class="el-timeline-item"
                      >
                        <div class="el-timeline-item__tail"></div>
                        <img
                          src="~images/index/btnGroup/node.png"
                          class="node__img"
                        />
                        <div class="el-timeline-item__wrapper">
                          <div class="el-timeline-item__timestamp is-top">
                            {{
                              $formatDate(
                                new Date(item1.systemusertime),
                                "yyyy-MM-dd"
                              )
                            }}
                          </div>
                          <div class="el-timeline-item__content">
                            <div
                              class="flex"
                              style="padding:0px 10px 0 5px;align-items: flex-start;"
                            >
                              <border-box>
                                <img class="infoImg" v-lazy="item1.img" />
                              </border-box>
                              <div class="msg">{{ item1.info }}</div>
                            </div>
                          </div>
                          <div
                            class="el-timeline-item__timestamp is-bottom"
                          ></div>
                        </div>
                      </li>
                    </ul>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </bar-card>
        </div>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import {
  findWebsiteNewsByYear,
  getScreenV2DataProcessGetYear
} from "@/api/home";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeName: " ",
      allList: [],
      list: [],
      years: []
    };
  },
  computed: {
    ...mapGetters(["rightComponentBak"])
  },
  mounted() {
    this.yjListData();
    this.allArr();
  },
  methods: {
    closeClick() {
      this.$store.dispatch(
        "drawer/setRightComponent",
        this.rightComponentBak || "rightDrawer"
      );
    },
    yjListData() {
      getScreenV2DataProcessGetYear().then(res => {
        console.log("getScreenV2DataProcessGetYear", res);
        this.years = res.data;
      });
    },
    allArr() {
      this.allList = [];
      findWebsiteNewsByYear({ year: "" }).then(res => {
        res.data.map(v => {
          v.img = this.$config.imgIp + v.img;
        });
        this.allList = res.data;
      });
    },
    someArr(value) {
      this.list = [];
      findWebsiteNewsByYear({ year: value }).then(res => {
        res.data.map(v => {
          if (!/^http[s]{0,1}:\/\/.*/i.test(v)) {
            v.img = this.$config.imgIp + v.img;
          }
        });
        this.list = res.data;
      });
    },
    handleClick(tab) {
      if (tab.name == "") {
        this.allArr();
      } else {
        this.someArr(tab.name);
      }
    }
  },
  destroyed() {}
};
</script>

<style lang="stylus" scoped>
.panel
  height calc(100% - 8px)
  width 100%
  font-size 0.06rem
.content
  height calc(100% - 43px)
  width calc(100% - 20px)
  padding 0 10px
  position relative
.closeDraw
  position absolute
  right 10px
  top -30px
  .el-button
    background transparent
    color #fff
    font-size 25px
    padding 0
    border 0
    position relative
.realTime
  padding 10px
  color #fff
  border 1px solid #4E8294
  border-radius 8px
  background-color rgba(30, 49, 93, 0.3)
  height 120px
  margin-top 10px
  box-shadow inset 0 0 10px rgba(104, 213, 240, 0.7)
.tabPanel
  height calc(100% - 10px)
  width 100%
  color #0ff
  >>>.el-tabs
    height 100%
  >>>.el-tabs__header
    margin-bottom 5px
  >>>.el-tabs__content
    height calc(100% - 40px)
  >>>.el-tab-pane
    height 100%
  >>>.el-tabs__item
    color #fff
    font-size 0.08rem
  >>>.el-tabs__item.is-active
    color #0ff
  >>>.el-tabs__active-bar
    background-color #0ff
  >>>.el-tabs__nav-wrap::after
    background-color transparent
  .el-timeline
    height 100%
    overflow-y auto
    padding-top 5px
    .el-timeline-item__timestamp
      font-family 'electronicFont'
      font-size 0.08rem
      color #0ff
    .el-timeline-item__timestamp.is-top
      margin-bottom 5px
      padding-top 2px
    .el-timeline-item__tail
      left 6px
      border-color #0ff
    .el-timeline-item__node--normal
      left 0
    &::-webkit-scrollbar
      width 4px
      background-color #00162D
    /* 定义滚动条轨道 内阴影+圆角 */
    &::-webkit-scrollbar-track
      -webkit-box-shadow inset 0 0 6px transparent
      background-color transparent
    /* 定义滑块 内阴影+圆角 */
    &::-webkit-scrollbar-thumb
      border-radius 10px
      -webkit-box-shadow inset 0 0 6px transparent
      background-color #0ff
    /* 定义最上方和最下方的按钮 */
    &::-webkit-scrollbar-button
      height 0
  .el-timeline-item
    color #fff
    padding-bottom 4px
  .el-timeline-item__wrapper
    padding-left 18px
  .el-timeline-item:last-child
    padding-bottom 4px
.node__img
  position absolute
  left -5px
  top -6px
.infoImg
  width 100%
.msg
  font-size 0.08rem
  letter-spacing 2px
  color #0ff
  padding-left 10px
  line-height 0.11rem
  flex 1
  font-family Arial, '宋体'
.cube
  cursor pointer
.flex
  display flex
  align-items center
@media (min-height 1400px)
  .content
    height calc(100% - 79px)
  .rightBar
    >>>.side
      width 24% !important
  .closeDraw
    top -60px
    right 20px
    .el-button
      font-size 40px
@media (max-width 1280px)
  .content
    height calc(100% - 25px)
  .tabPanel>>>.el-tabs__item
    height 30px !important
    line-height 30px !important
  .tabPanel>>>.el-tabs__header
    margin 0 0 5px !important
  .el-timeline
    .el-timeline-item__timestamp
      font-size 0.11rem !important
    .el-timeline-item__content
      font-size 0.09rem !important
  .closeDraw
    top -20px
    .el-button
      font-size 15px
</style>
